import { createActions } from 'redux-actions';

export const {
  updateSystemEmailTemplates,
  removeSystemEmailTemplate,
} = createActions('UPDATE_SYSTEM_EMAIL_TEMPLATES', 'REMOVE_SYSTEM_EMAIL_TEMPLATE');
